<template>
  <div
    v-if="r!== null"
    class="request-item"
  >
    <div
      v-if="!isArchive"
      @click.prevent="$router.push(`/dashboard/request/${r.id}`)"
    >
      <div class="request-title">
        {{ r.title }}
      </div>

      <div>
        <div class="badge bg-dark mr-2">
          {{ requestName }}
        </div>
        <div class="badge badge-light mr-2">
          <img src="@/assets/images/icons/list-order.png">
          {{ r.requestType }}{{ buildLongId(r.id) }}
        </div>

        <div class="badge badge-light mr-2">
          <img src="@/assets/images/icons/calendar.png">
          {{ $t('dashboardCompany.key', {moment: getMoment(r.logTime)}) }}
        </div>

        <span
          v-if="r.isRead===0"
          class="badge bg-success"
        >
          <img src="@/assets/images/icons/bolt.png">
          {{ $t('requestItem.yeni') }}
        </span>
      </div>


      <div class="d-flex justify-content-between align-items-center mt-3">
        <div class="d-flex align-items-center request-author">
          <img
            :src="getPhoto(r.user.photo,'thumbnailCropped')"
            class="img-thumbnail rounded-circle mr-2"
            style="height: 40px; width: 40px;"
          >
          <div>
            <span class="name">{{ r.user.name }}  {{ r.user.surname }}</span> <br>
            <span class="text-secondary company-name">
              {{ r.company.name }}
              {{ getCompanyFormat(r.company.format) }}
            </span>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center">
            <span
              v-if="r.status === 'ACTIVE'"
              class="badge bg-success mr-2"
            >{{ $t('requestItem.aktivSoru') }}</span>
            <span
              v-else-if="r.status === 'EXPIRED'"
              class="badge bg-warning mr-2"
            >{{ $t('requestItem.mddtiBitib') }}</span>
            <span
              v-else-if="r.status === 'DISCUSSING'"
              class="badge bg-warning mr-2"
            >{{ $t('requestItem.mzakirGedir') }}</span>

            <span
              v-if="r.requestType === 'POL'"
              class="badge bg-danger"
            >{{ $t('requestItem.ss', {commentCount: r.commentCount}) }}</span>
            <span
              v-else-if="['AUC','REV','RFQ','PQT','LOG'].indexOf(r.requestType)>-1"
              class="badge bg-danger"
            >
              {{ $t('requestItem.tklif', {commentCount: r.commentCount}) }}
            </span>
            <span
              v-else
              class="badge bg-danger"
            >
              {{ $t('requestItem.rh', {commentCount: r.commentCount}) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      @click.prevent="archiveRequestClicked()"
    >
      <div class="request-title">
        {{ r.title }}
      </div>

      <div>
        <div class="badge bg-dark mr-2">
          {{ requestName }}
        </div>
        <div class="badge badge-light mr-2">
          <img src="@/assets/images/icons/list-order.png">
          {{ r.requestType }}{{ buildLongId(r.id) }}
        </div>

        <div class="badge badge-light mr-2">
          <img src="@/assets/images/icons/calendar.png">
          {{ $t('dashboardCompany.key', {moment: getMoment(r.logTime)}) }}
        </div>
      </div>

      <p class="request-description">
        {{ r.description }}
      </p>
    </div>
  </div>
</template>
<script>
import {buildLongId, getCompanyFormat, getPhoto, requestName} from "@/repositories/Utils";
import {mapState} from "vuex";
import Swal from "sweetalert2";
import {changeCompanyUserSectorsAdd} from "@/repositories/GeneralDataRepository";
import moment from "moment";

export default {
  name: 'RequestItem',
  props: {
    activeTab: {
      type: String,
      default() {
        return 'request';
      }
    },
    isArchive: {
      type: Boolean,
      default() {
        return false;
      }
    },
    r: {
      type: Object,
      default() {
        return null;
      }
    },
    sector: {
      type: Object,
      default() {
        return null;
      }
    }
  },

  computed: {
    ...mapState({
      profile: state => state.auth.profile,
      token: state => state.auth.token,
      packageStatus: state => state.auth.userPackageStatus,
    }),
    requestName() {
      console.log(this.r);
      return requestName(this.r);

    }
  },

  methods: {
    getMoment(time){
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY')
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    archiveRequestClicked() {

      if (this.activeTab === 'archive') {
        this.$swal({
          title: this.$t("requestItem.arxivSrg"),
          text: this.$t("requestItem.rxvSrglrnMlmtXrkt"),
          icon: 'error'
        })
      } else {

        if (this.packageStatus === 'ok' && this.profile === 'SUPPLIER') {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("requestItem.sectorNotSelected"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t("newPolRequest.bli"),
            cancelButtonText: this.$t("newPolRequest.dahaSonra"),
          }).then((result) => {
            if (result.value) {
              this.$swal({
                title: this.$t("newPolRequest.confirmAgain"),
                confirmButtonText: this.$t("newPolRequest.confirm"),
                html: `<label><input type="checkbox" id="confirmSector"> ${this.sector.name}</label>`,
                focusConfirm: false,
                preConfirm: () => {
                  let checkboxValue = document.getElementById('confirmSector').checked;
                  return {confirmed: checkboxValue};
                }
              }).then((secondResult) => {
                if (secondResult.value && secondResult.value.confirmed) {
                  // Call your function here
                  changeCompanyUserSectorsAdd(this.token, this.sector.id).then(data => {
                        if (data.message === "OK") {
                          this.$swal({
                            title: this.$t("generalModal.warningTitle"),
                            text: this.$t("newPolRequest.successAdded"),
                            icon: "success"
                          }).then(() => {
                            // Reload the page in any case
                            location.reload();
                          });
                        } else {
                          console.log(data)
                          this.$swal({
                            title: this.$t("generalModal.warningTitle"),
                            text: this.$t("requestItem.errOccured"),
                            icon: "error"
                          })
                        }
                      }
                  )
                }
              });
            }
          })
        } else {

          this.$swal({
            title: this.$t("changeAccount.abunlik"),
            text: this.$t("changeAccount.srgDetallari"),
            icon: 'warning',

            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t("sidebar.abunliyim"),
            cancelButtonText: this.$t("newPolRequest.dahaSonra")

          }).then((result) => {
            if (result.value) {
              this.$router.push({name: 'subscriptionPage'});
            }
          })

        }

      }

    }
  }
}
</script>
<style lang="scss" scoped>
.request-item {
  cursor: pointer;
  padding: 20px;
  border-radius: 6px;

  .request-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .request-description {
    color: #5D6B82;
  }

  .request-author {

    .name {
      font-size: 14px;
    }

    .company-name {
      font-size: 12px;
    }

  }

  &:hover {
    background-color: rgba(#2062FB, 0.05);

    .request-title {
      color: #2062FB;
    }
  }

}
</style>
